export type CleanerHosePose = {
  lengthScale: number;
  ikInfluence: number;
};

export const CLEANER_HOSE_IDLE_LENGTH_SCALE = 0.5;
export const CLEANER_HOSE_ACTIVE_LENGTH_SCALE = 1;
export const CLEANER_HOSE_CONTROL_READY_PROGRESS = 0.14;
export const CLEANER_HOSE_FULL_CONTROL_PROGRESS = 0.82;
export const CLEANER_HOSE_SUCTION_READY_PROGRESS = 0.9;
const CLEANER_HOSE_RELEASE_REST_FOLLOW = 8;

const clamp01 = (value: number) => Math.min(Math.max(value, 0), 1);
const lerp = (from: number, to: number, progress: number) =>
  from + (to - from) * progress;
const easeOutCubic = (progress: number) => 1 - Math.pow(1 - progress, 3);

export const getCleanerHosePose = (progress: number): CleanerHosePose => {
  const normalizedProgress = clamp01(progress);
  const normalizedIkProgress = clamp01(
    (normalizedProgress - CLEANER_HOSE_CONTROL_READY_PROGRESS) /
      (CLEANER_HOSE_FULL_CONTROL_PROGRESS - CLEANER_HOSE_CONTROL_READY_PROGRESS)
  );

  return {
    lengthScale: lerp(
      CLEANER_HOSE_IDLE_LENGTH_SCALE,
      CLEANER_HOSE_ACTIVE_LENGTH_SCALE,
      easeOutCubic(normalizedProgress)
    ),
    ikInfluence: easeOutCubic(normalizedIkProgress),
  };
};

export const getCleanerHoseReleaseRestBlend = (deltaSeconds: number) =>
  1 - Math.exp(-Math.max(0, deltaSeconds) * CLEANER_HOSE_RELEASE_REST_FOLLOW);
